<template>
  <div class="box">
    <div class="box-header">
      <h3>Application Setting</h3>
    </div>
    <div class="box-body">
      <div class="options_tab">
        <ul>
          <li @click="tabToggle(i.optionName)" v-for="(i, index) in optionsTab" :key="index"
            :class="{ active: selectedOption === i.optionName }">
            {{ i.optionName }}
          </li>
        </ul>
      </div>
      <div class="tabs-content">
        <div class="content">
          <!-- Default Start -->
          <div class="input-group" v-if="ApplicationSetting === 'Default'">
            <div class="field">
              <p class="check ed" @click="form.isCoverLetter = !form.isCoverLetter" v-if="form.isCoverLetter">
                <i class="fa-solid fa-square-check"></i>
                Cover Letter is Required
              </p>
              <p class="check" v-else @click="form.isCoverLetter = !form.isCoverLetter">
                <i class="fa-regular fa-square"></i>
                Cover Letter is not Required
              </p>
            </div>

            <div class="field">
              <label class="label">
                Email
                <span>
                  (ເມວທີ່ຈະໄດ້ຮັບ CV ຂອງຜູ້ສະໝັກຜ່ານປຸ່ມ Applyຂອງເວັບໄຊທ)
                </span>
              </label>

              <!-- Default Email required -->
              <!-- <div class="control">
                <input type="text" class="input" placeholder="Email" />
              </div> -->
              <!-- Default Email required -->

              <!-- More Email Optional -->
              <div class="control has-icon" v-for="(i, index) in form.appliedEmails" :key="index">
                <input type="text" class="input" placeholder="Email" v-model="form.appliedEmails[index]" />
                <i class="fa-light fa-trash" @click="form.appliedEmails.splice(index, 1)" v-if="index !== 0"></i>
              </div>
              <button class="button primary small" v-if="form.appliedEmails.length < 10"
                @click="form.appliedEmails.push('')">Add Email</button>
            </div>
          </div>
          <!-- Default End -->

          <!-- Hide Apply Button Start -->
          <p v-if="ApplicationSetting === 'Hide Apply Button'">
            ປະກາດວຽກຈະບໍ່ມີປຸ່ມ Apply, ຜູ້ຊອກວຽກຈະຕ້ອງສະໝັກຕາມຂໍ້ມູນທີ່ລະບຸໃນ
            Job Description ເທົ່ານັ້ນ
          </p>
          <!-- Hide Apply Button End -->

          <!-- External Link Start -->
          <div class="field" v-if="ApplicationSetting === 'External Link'">
            <label class="label">
              External Link
              <span>
                (ລິ້ງດາວໂຫລດແບບຟອມສະໝັກ, ລິ້ງໄປອ່ານເນື້ອໃນປະກາດວຍກເພີ່ມເຕີມ)
              </span>
            </label>
            <div class="control">
              <input type="text" class="input" v-model="form.isURL" />
            </div>
          </div>
          <!-- External Link End -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["info"],
  data: () => ({
    optionsTab: [
      {
        optionName: "Default",
      },
      {
        optionName: "Hide Apply Button",
      },
      {
        optionName: "External Link",
      },
    ],
    ApplicationSetting: "Default",
    selectedOption: "Default",
    requireCoverLetter: true,
    form: {
      isCoverLetter: true,
      appliedEmails: [""],
      isHideApplyButton: false,
      isNotApply: false,
      isApplyUrl: false,
      isURL: ""
    }
  }),

  methods: {
    tabToggle(i) {
      this.ApplicationSetting = i;
      this.selectedOption = i;
      if (i === "Hide Apply Button") {
        this.form.isHideApplyButton = true
        this.form.isNotApply = true
        this.form.isApplyUrl = false
        this.form.isURL = ""
        this.form.isCoverLetter = false
      } else if (i === "External Link") {
        this.form.isHideApplyButton = false
        this.form.isNotApply = false
        this.form.isApplyUrl = true
        this.form.isCoverLetter = false
      } else {
        this.form.isHideApplyButton = false
        this.form.isNotApply = false
        this.form.isApplyUrl = false
        this.form.isURL = ""
        this.form.isCoverLetter = false
      }
    },
  },
  watch: {
    form: {
      handler(val) {
        if (val) {
          this.$emit('input', val)
        }
      },
      immediate: true,
      deep: true
    },
    "info": {
      handler(val) {
        if (val) {
          this.form.appliedEmails = val.appliedEmails ? val.appliedEmails : [""]
          // if (val.isCoverLetter) { 
            this.form.isCoverLetter = val.isCoverLetter
            this.ApplicationSetting = "Default"
            this.selectedOption = "Default"
          // }
          if (val.isHideApplyButton) {
            this.form.isHideApplyButton = val.isHideApplyButton
            this.ApplicationSetting = "Hide Apply Button"
            this.selectedOption = "Hide Apply Button"
          }
          if (val.isApplyUrl && val.isURL) {
            this.form.isApplyUrl = val.isApplyUrl
            this.form.isURL = val.isURL ? val.isURL : ""
            this.ApplicationSetting = "External Link"
            this.selectedOption = "External Link"
          }
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  color: var(--text-color) !important;

  &.check {
    margin-bottom: 20px;
    cursor: pointer;
    color: var(--grey-color) !important;

    &.ed {
      cursor: pointer;
      color: var(--primary-color) !important;
    }
  }
}

.options_tab {
  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
    display: flex;
    gap: 10px;
    margin-bottom: 10px;

    li {
      margin: 0;
      display: flex;
      align-items: center;
      cursor: pointer;
      background-color: var(--light-grey-color);
      padding: 0 20px;
      height: 2.5rem;
      border-radius: var(--radius);
      font-size: var(--sm-font);

      &.active {
        background-color: rgba(var(--primary-color-rgb), 0.09);
        color: var(--primary-color) !important;
        border: 2px solid var(--primary-color);
      }
    }
  }
}

.tabs-content {
  border: 1px solid var(--border-color);
  padding: 20px;
  border-radius: var(--radius);
}
</style>
